/**
 * Trending pages module.
 *
 * Pulls /api/trending periodically and exposes a tiny "is this alert
 * trending?" lookup keyed by the last 6 hex chars of the alert id.
 * The trending rule lives server-side (services/umami.py).
 */

const TRENDING_CHECK_INTERVAL = 10 * 60 * 1000;

let trendingPages = [];
let trendingAlertSuffixes = new Set(); // id_suffix of trending alerts

let trendingInterval = null;

/**
 * Initialize trending data fetching.
 */
export function initTrending() {
    fetchTrending();
    trendingInterval = setInterval(fetchTrending, TRENDING_CHECK_INTERVAL);

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            clearInterval(trendingInterval);
            trendingInterval = null;
        } else if (!trendingInterval) {
            fetchTrending();
            trendingInterval = setInterval(fetchTrending, TRENDING_CHECK_INTERVAL);
        }
    });
}

async function fetchTrending() {
    try {
        const response = await fetch('/api/trending?hours=2&limit=5');
        if (!response.ok) return;

        const data = await response.json();
        if (!data.available) return;

        trendingPages = data.pages || [];

        trendingAlertSuffixes.clear();
        for (const page of trendingPages) {
            if (page.page_type === 'alert' && page.id_suffix) {
                trendingAlertSuffixes.add(page.id_suffix);
            }
        }
    } catch (error) {
        console.warn('Failed to fetch trending data:', error);
    }
}

/**
 * @param {string} alertId - Full alert ID
 * @returns {{ trending: boolean }}
 */
export function getAlertTrending(alertId) {
    if (!alertId || trendingAlertSuffixes.size === 0) {
        return { trending: false };
    }
    return { trending: trendingAlertSuffixes.has(alertId.slice(-6)) };
}
